"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var useStyles = (0, _styles.makeStyles)({
  root: function root(props) {
    return {
      '&::after': {
        content: props.required ? '" *"' : ''
      }
    };
  }
});
var SttHeadding = function SttHeadding(props) {
  var classes = useStyles(props);
  return /*#__PURE__*/_react["default"].createElement(_core.Typography, _extends({
    className: classes.root
  }, props));
};
var _default = SttHeadding;
exports["default"] = _default;